import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import APIS from "./utils/APIS"
import { isLoggedIn, setUser } from "./utils/auth"

import { ConfirmProvider } from "material-ui-confirm";

const checkLoggedRefresh = () => {
  //console.log("checkLoggedRefresh")
  APIS.getLoginStatus().then(result => {
    if (result?.message == "status" && result?.user) {
      let actUser = isLoggedIn()
      if (actUser === false) {
        //on doit donc logger le user et reload
        setUser(result?.user)
        document.location.reload()
      } else {
        if (actUser !== result?.user?.id) { //problème, on logout et reload
          setUser({})
          document.location.reload()
        }
      }
    } else {
      if (isLoggedIn()) {
        setUser({})
        document.location.reload()
      }
    }
  })
}
checkLoggedRefresh()


ReactDOM.render(
  (
    <BrowserRouter>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  ),
  document.getElementById('root')
);
